import script from "./Trial.vue?vue&type=script&setup=true&lang=ts"
export * from "./Trial.vue?vue&type=script&setup=true&lang=ts"

import "./Trial.vue?vue&type=style&index=0&id=36bb8fcb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bb8fcb"]])

export default __exports__